import { render, staticRenderFns } from "./ModalShowEvidence.vue?vue&type=template&id=04b29156&"
import script from "./ModalShowEvidence.vue?vue&type=script&lang=js&"
export * from "./ModalShowEvidence.vue?vue&type=script&lang=js&"
import style0 from "./ModalShowEvidence.vue?vue&type=style&index=0&id=04b29156&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports